import * as React from 'react';
import { useCallback, useState } from 'react';
import { useAppTranslation } from '../../services/i18n';
import { useAppDispatch } from '../../store';
import { deleteUserLabel } from '../../store/userLabels';
import { addMessage } from '../../store/localApp';
import { isApiResultError } from '../../helpers/api';
import { ConfirmDialog } from '../ConfirmDialog';
import { UserLabel } from '../../generated-api';

type Props = {
  item: UserLabel;
  onSuccess: () => unknown;
  onClose: () => unknown;
};

export const UserLabelDeleteForm = (props: Props) => {
  const t = useAppTranslation();
  const dispatch = useAppDispatch();
  const [isSaving, setIsSaving] = useState(false);

  const { item, onSuccess, onClose } = props;

  const handleDeleteItem = useCallback(async () => {
    setIsSaving(true);
    const result = await dispatch(deleteUserLabel({ id: '' + item.id }));
    setIsSaving(false);

    if (!isApiResultError(result)) {
      dispatch(addMessage({ severity: 'success', title: t('userLabels.form.success.deleted') }));
      onSuccess();
      onClose();
    }
  }, [dispatch, item.id, onSuccess, onClose, t]);

  return (
    <ConfirmDialog
      title={t('userLabels.deleteOne')}
      action={t('form.delete')}
      onConfirm={handleDeleteItem}
      onCancel={onClose}
      isSaving={isSaving}
    >
      <>
        <p>{t('userLabels.form.deleteConfirm', { name: item.name })}</p>
        <p>
          {item.user_count
            ? t('userLabels.form.deleteConfirmCount', { count: item.user_count })
            : t('userLabels.form.deleteConfirmNoUsers')}
        </p>
      </>
    </ConfirmDialog>
  );
};
